import { Box, Heading, Text, Icon, LinkBox, LinkOverlay } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom'
import type { IconType } from 'react-icons'

interface CanvassingToolCardProps {
  title: string
  description: string
  icon: IconType
  to: string
  listId?: string
  isDisabled?: boolean
}

export function CanvassingToolCard({
  title,
  description,
  icon,
  to,
  listId,
  isDisabled = false,
}: CanvassingToolCardProps) {
  const navigate = useNavigate()

  const handleClick = () => {
    if (isDisabled) return
    const url = listId ? `${to}?listId=${listId}` : to
    navigate(url)
  }

  return (
    <LinkBox
      bg="surface"
      p={6}
      borderRadius="lg"
      shadow="md"
      transition="all 0.2s"
      _hover={isDisabled ? {} : { shadow: 'lg', transform: 'translateY(-2px)' }}
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      opacity={isDisabled ? 0.6 : 1}
      asChild><Box onClick={handleClick}>
        <Icon as={icon} boxSize={8} color="accent" mb={4} />
        <Heading size="md" mb={2}>
          <LinkOverlay>{title}</LinkOverlay>
        </Heading>
        <Text color="gray.600" fontSize="sm">
          {description}
        </Text>
        {isDisabled && (
          <Text color="gray.500" fontSize="xs" fontWeight="medium" mt={3}>
            COMING SOON
          </Text>
        )}
      </Box></LinkBox>
  );
}
